import { render, staticRenderFns } from "./TerminationContract.vue?vue&type=template&id=22382b4c&"
import script from "./TerminationContract.vue?vue&type=script&lang=js&"
export * from "./TerminationContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports